import * as Yup from "yup";

export const EXPENSE_EDIT_FORM_SCHEMA = Yup.object().shape({
  expenseTypeId: Yup.string().nullable().required("Vrsta troška je obavezna"),
  name: Yup.string().nullable().required("Naziv je obavezan"),
  expenseDate: Yup.date().nullable().required("Datum troška je obavezan"),
  amount: Yup.number().nullable().required("Iznos je obavezan"),
});
